import script from "./FormulasPrizeModal.vue?vue&type=script&setup=true&lang=js"
export * from "./FormulasPrizeModal.vue?vue&type=script&setup=true&lang=js"

import "./FormulasPrizeModal.vue?vue&type=style&index=0&id=0f3f0931&lang=scss"

const __exports__ = script;

export default __exports__